import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AddCardRequest} from '../../../../core/requests/AddCardRequest';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-add-card',
  templateUrl: './add-card.component.html',
  styleUrls: ['./add-card.component.scss']
})
export class AddCardComponent implements OnInit {

  public addCardForm: FormGroup | null = null;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.addCardForm = this.fb.group({
      cardNumber: ['', Validators.required],
      name: ['', Validators.required],
      expiredDate: ['', Validators.required],
      securityCode: ['', Validators.required]
    });
  }

  addCard() {
    const params: AddCardRequest = {
      cardNumber: this.addCardForm.get('cardNumber')?.value,
      name: this.addCardForm.get('name')?.value,
      expiredDate: this.addCardForm.get('expiredDate')?.value,
      securityCode: this.addCardForm.get('securityCode')?.value
    };
    // @ts-ignore
    this.addCardForm(params)
      .subscribe(
        data => {
          this.onAddCardSuccess();
        },
        error => {
          this.onAddCardFail(error);
        });
  }

  public onAddCardSuccess() {
    this.closeBtnClick();
  }

  public onAddCardFail(error: HttpErrorResponse) {}

  public closeBtnClick() {
    this.addCardForm = this.fb.group({
      cardNumber: ['', Validators.required],
      name: ['', Validators.required],
      expiredDate: ['', Validators.required],
      securityCode: ['', Validators.required]
    });
    this.activeModal.close();
  }

}
